import { type PropsWithChildren } from 'react'
import {
  Card,
  Spinner,
  type DropdownItemObject
} from '@jana-technology/platform-ui'

interface IGenericDonutChart extends PropsWithChildren {
  actionMenuItems?: DropdownItemObject[]
  showLoading: boolean
  title: string
}

export const GenericDonutChart = ({
  actionMenuItems,
  children,
  showLoading,
  title
}: IGenericDonutChart) => {
  return (
    <Card
      title={title}
      actionMenuItems={actionMenuItems}
      className='h-full min-h-full'
    >
      {showLoading ? (
        <div className='flex h-[393px] items-center justify-center text-center'>
          <Spinner label='Loading...' size='medium' />
        </div>
      ) : (
        <div className='flex justify-center'>{children}</div>
      )}
    </Card>
  )
}
